import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import StatsCard from '../components/StatsCard';
import SalesChart from '../components/SalesChart';
import RecentDeals from '../components/RecentDeals';
import ActivityFeed from '../components/ActivityFeed';
import DealsPipeline from '../components/DealsPipeline';
import {api} from '../../api';

export default function Dashboard() {
  const [deals, setDeals] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    api('/deals').then(r => r.json()).then(setDeals).catch(() => {});
    api('/contacts').then(r => r.json()).then(setContacts).catch(() => {});
    api('/companies').then(r => r.json()).then(setCompanies).catch(() => {});
    api('/crm-activities').then(r => r.json()).then(setActivities).catch(() => {});
  }, []);

  const totalRevenue = deals
    .filter(d => d.stage === 'CLOSED_WON')
    .reduce((sum, d) => sum + (d.value || 0), 0);

  const activeDeals = deals.filter(d => !['CLOSED_WON', 'CLOSED_LOST'].includes(d.stage)).length;

  return (
    <Layout>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <StatsCard title="Total Revenue" value={`$${totalRevenue.toLocaleString()}`} />
        <StatsCard title="Contacts" value={String(contacts.length)} />
        <StatsCard title="Active Deals" value={String(activeDeals)} />
        <StatsCard title="Companies" value={String(companies.length)} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <SalesChart deals={deals} />
        <DealsPipeline deals={deals} />
      </div>
      <div className="grid grid-cols-1 gap-6 mb-6">
        <RecentDeals deals={deals} />
      </div>
      <ActivityFeed activities={activities} />
    </Layout>
  );
}
